import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';

export const Fade = trigger('fade', [
  transition(':enter', [style({ opacity: 0 }), animate('0.3s ease-out', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('0.3s ease-in', style({ opacity: 0 }))])
]);

export const Reveal = trigger('reveal', [
  state('false', style({ height: '0' })),
  state('true', style({ height: '*' })),
  transition('true <=> false', animate('.3s .3s cubic-bezier(.25,.1,.25,1)'))
]);

export const List = trigger('list', [
  transition('* => *', [
    query(':leave', [stagger(100, [animate('0.3s ease-in', style({ opacity: 0 }))])], { optional: true }),
    query(':enter', [style({ opacity: 0 }), stagger(100, [animate('0.3s ease-out', style({ opacity: 1 }))])], {
      optional: true
    })
  ])
]);

export const SwitchFade = trigger('enterTrigger', [
  state('switchFade', style({ opacity: 1 })),
  transition('void => *', [style({ opacity: 0 }), animate('0.35s ease-out')])
]);
